module.exports = __webpack_public_path__ + "img/1.daf9cb6c.png";